const INCHES_TO_CENTIMETERS = 2.54
const LBS_TO_KG = 0.453592

export class UnitConversion {
  static centimetersToFeetAndInches(centimeters: number): {
    feet: number
    inches: number
  } {
    const inches = this.centimetersToInches(centimeters)
    return { feet: Math.floor(inches / 12), inches: inches % 12 }
  }

  static centimetersToInches(centimeters: number): number {
    return Math.round(centimeters / INCHES_TO_CENTIMETERS)
  }

  static feetAndInchesToCentimeters(feet: number, inches: number): number {
    return Math.round(this.inchesToCentimeters(feet * 12 + inches))
  }

  static inchesToCentimeters(inches: number): number {
    return Math.round(inches * INCHES_TO_CENTIMETERS)
  }

  static poundsToKilograms(lbs: number): number {
    return Math.round(lbs * LBS_TO_KG)
  }

  static kilogramsToPounds(kg: number): number {
    return Math.round(kg / LBS_TO_KG)
  }
}
